import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const WaterAndSewage = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Agua e Esgoto'}
            horizontal={true}
            subtitles={
                chartData?.waterAndSewage?.map((item) => item.description) || []
            }
            values={chartData?.waterAndSewage?.map((item) => item.total  ||  0) || []}
            className='aligned-container'
        />
    );
};
